"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const utils_1 = require("data/transactions/utils");
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const AccountsMenu_1 = __importDefault(require("components/QuickenControls/AccountsMenu"));
const retrievers_1 = require("data/accounts/retrievers");
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const AccountField = ({ attributes, forceStatic, callbacks, SHOW_ALL, fieldActive, txn, wrapClass, showAccountColors, accountColorForId, accountMenuEl, updateAccountMenuEl, editable, focusField, bankPendingClass, }) => {
    const { classes } = useStyles();
    const flexClass = showAccountColors ? 'none' : 'flex1 protectWidth';
    const regClass = showAccountColors ? '' : classes.regItem;
    const acctName = (0, retrievers_1.getAccountString)(txn.accountId);
    const c2RTxnClass = (0, utils_1.isC2RTransaction)(txn) ? classes.txnInC2RText : '';
    const renderCore = () => (<>
      {showAccountColors &&
            <div className={classes.accountFieldColor}>
          <div className={classes.accountColorDiv} style={{ background: accountColorForId }}>
          </div>
        </div>}

      {!showAccountColors &&
            <div className={(0, classnames_1.default)(classes.accountFieldName, bankPendingClass, c2RTxnClass)}>
          <QTip_1.default title={acctName} 
            // @ts-expect-error: Property 'distance' does not exist
            distance={3} wrapOnly position="bottom" wrapId={`${txn.id}-account`}>
            <QTypography_1.default thinFont clickable className={classes.regItemCore}>
              {acctName}
            </QTypography_1.default>
          </QTip_1.default>
        </div>}
    </>);
    return (<styles_1.RegListItem {...attributes} className={(0, classnames_1.default)(fieldActive && 'editable', regClass, flexClass, fieldActive ? 'wraptext' : wrapClass)} tabIndex="0">
      {SHOW_ALL &&
            <>
          {editable &&
                    // @ts-expect-error: missing props
                    <ButtonBase_1.default id={`${showAccountColors ? 'AcctColorMenu' : 'AcctMenu'}${txn.id}`} aria-label="Account Menu" classes={{ root: classes.buttonRoot }} focusRipple autoFocus disabled={forceStatic} ref={fieldActive ? (input) => {
                            focusField.current = input; // eslint-disable-line
                        } : null} onClick={fieldActive ? (e) => updateAccountMenuEl(e.currentTarget) : null}>
            {renderCore()}
          </ButtonBase_1.default>}

          {!editable && renderCore()}

          {editable && fieldActive && accountMenuEl && (<AccountsMenu_1.default element={accountMenuEl} selected={txn.accountId} showColors={showAccountColors} onChange={(event) => {
                        var _a;
                        updateAccountMenuEl(null);
                        (_a = callbacks.handleChange) === null || _a === void 0 ? void 0 : _a.call(callbacks, event, 'account');
                    }} onClose={() => {
                        updateAccountMenuEl(null);
                        setTimeout(() => { var _a; return (_a = callbacks.resetFocus) === null || _a === void 0 ? void 0 : _a.call(callbacks); }, 100);
                    }}/>)}
        </>}
    </styles_1.RegListItem>);
};
exports.default = AccountField;
